<template>
    <div id="login">
        <div class="loginMain">
            <div class="content">
                <div class="logoTitle">
                    <img class="logoImg" src="../../assets/img/tr_Logo.svg" alt="">
                    <span>用户中台管理系统</span>
                </div>
                <div class="loginForm">
                    <span>账户密码登录</span>

                    <el-form :model="loginForm" ref="loginForm" :rules="rules" class="mainForm">
                        <el-form-item prop="userName">
                            <el-input
                                    v-model="loginForm.username"
                                    maxlength="20"
                                    placeholder="请输入用户名"
                            >
                                <i slot="prefix">
                                    <img
                                            style="margin-top: 10px"
                                            src="../../assets/img/login_user_icon.svg"
                                            alt
                                    />
                                </i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input
                              @keyup.enter.native="login"
                              type="password"
                                    v-model="loginForm.password"
                                    maxlength="20"
                                    placeholder="请输入密码"
                            >
                                <i slot="prefix">
                                    <img
                                            style="margin-top: 10px"
                                            src="../../assets/img/login_password_icon.svg"
                                            alt
                                    />
                                </i>
                            </el-input>
                        </el-form-item>
                        <el-form-item v-loading="btnLoading">
                            <el-button type="primary" class="loginBtn" @click="login">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Message } from 'element-ui'

    export default {
        name: "Login",
        data() {
            return {
                rules: {},
                loginForm: {},
                btnLoading:false,
            }
        },
        methods: {
            async login(){
                localStorage.removeItem('accessToken')
                localStorage.removeItem('menuList')
                localStorage.removeItem('userInfo')
                this.btnLoading=true
                let params={
                    scope:"all",
                    grant_type:"password",
                    login_method:'M2',
                    user_type:'1',
                    ...this.loginForm
                };
                const res= await this.API.user.login(params);
                if (res.success){
                    this.getMenus()
                }else{
                    this.btnLoading=false
                }
            },
            async getMenus(){
                const res= await this.API.user.getMenus(
                    {clientId:'user-client'}
                    );
                if (res.success){
                    if(res.entity.length==0){
                        Message({
                            message:'该账号无访问权限',
                            type: 'warning',
                        });
                        this.btnLoading=false
                        return
                    }
                    this.btnLoading=false
                    localStorage.setItem('menuList',JSON.stringify(res.entity[0].menus))
                    if(res.entity[0].menus[0].submenu.length >0){
                        window.location.href = "/bussinessCenter.html#"+'/'+ res.entity[0].menus[0].code+'/'+res.entity[0].menus[0].submenu[0].code;
                    }else{
                        window.location.href = "/bussinessCenter.html#"+'/'+ res.entity[0].menus[0].code+'/'+res.entity[0].menus[0].path;

                    }

                }
            },
        },
        mounted() {
            localStorage.removeItem('accessToken')
            localStorage.removeItem('menuList')
        }
    }
</script>
<style>
    @import "~@assets/reset.css";

</style>
<style scoped lang="scss">
    #login {
        width: 100%;
        height: 100%;
        position: fixed;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .loginMain {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../../assets/img/Login_bg.svg");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .content {
        background: url("../../assets/images/login.svg") no-repeat center;
        width: 840px;
        height: 600px;
        opacity: 1;
        margin: 0 auto;
    }

    .logoTitle {
        width: 100%;
        padding: 45px 0 0 70px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .logoImg {
            width: 26px;
            height: 31px;
            margin-right: 12px;
        }

        span {
            height: 20px;
            opacity: 1;
            font-size: 20px;
            font-family: PingFang, PingFang-SC;
            font-weight: 600;
            text-align: left;
            color: #000000;
            line-height: 20px;
            letter-spacing: 0px;
        }
    }

    .loginForm {
        padding: 100px 0 0 70px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        span {
            font-size: 14px;
            font-family: PingFang, PingFang-SC;
            font-weight: 600;
            text-align: center;
            color: #1c2434;
            line-height: 14px;
            letter-spacing: 0px;
        }

        .mainForm {
            margin-top: 50px;

            .el-input__inner {
                border: 0px !important;
                border-bottom: 1px solid rgba(0, 0, 0, 0.10) !important;
            }
        }
    }

    #login .el-form-item {
        width: 250px;
        margin-bottom: 20px;
    }

    #login .el-input {
        font-size: 16px;
    }

    /* /deep/ .el-input__inner */
    ::v-deep .el-input__inner {
        height: 50px;
        line-height: 50px;
        border: none;
        border-radius: 0px;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        padding-left: 35px;
        position: relative;
        box-shadow: inset 0 0 0 1000px #ffffff !important;
    }

    #login {
        .loginBtn.el-button {
            width: 100%;
            background: #005eeb;
            border-color: #005eeb;
            border-radius: 6px;
            box-shadow: 0px 5px 10px 0px rgba(0, 102, 255, 0.20);

            ::v-deep span {
                color: white !important;
            }
        }
    }
</style>

